import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import { CONTEXT_POST_VERIFIER_BAN } from '../../constants/apiUrls.constants';

const adresseVerificationBAN = combineReducers({
    verifier: APIReducer.bind(null, CONTEXT_POST_VERIFIER_BAN),
});

export default adresseVerificationBAN;
